import { Observable } from 'rxjs';
import { ServiceCategoryModel, ServiceMasterCategoryModel, ServiceModel } from 'src/app/store/self-diagnostic/service-catalog/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractServiceCatalogApiService {
  public abstract getAll(): Observable<InteractorResponse<ServiceModel[]>>;
  public abstract enable(codes: number[]): Observable<InteractorResponse<ServiceModel[]>>;
  public abstract disable(codes: number[]): Observable<InteractorResponse<ServiceModel[]>>;
  public abstract sync(): Observable<InteractorResponse<ServiceModel[]>>;
  public abstract getByCode(code: number): Observable<InteractorResponse<ServiceModel>>;
  public abstract updateService(service: ServiceModel): Observable<InteractorResponse<ServiceModel>>;
  public abstract updateCategory(category: ServiceCategoryModel): Observable<InteractorResponse<ServiceCategoryModel>>;
  public abstract uploadCategoryIcon(category: ServiceCategoryModel, file: File): Observable<InteractorResponse<ServiceCategoryModel>>;
  public abstract deleteCategoryIcon(category: ServiceCategoryModel): Observable<InteractorResponse<ServiceCategoryModel>>;
  public abstract uploadMasterCategoryIcon(
    masterCategory: ServiceMasterCategoryModel,
    file: File
  ): Observable<InteractorResponse<ServiceMasterCategoryModel>>;
  public abstract deleteMasterCategoryIcon(
    masterCategory: ServiceMasterCategoryModel
  ): Observable<InteractorResponse<ServiceMasterCategoryModel>>;
  public abstract upPriorityCategory(category: ServiceCategoryModel): Observable<InteractorResponse<ServiceCategoryModel>>;
  public abstract downPriorityCategory(category: ServiceCategoryModel): Observable<InteractorResponse<ServiceCategoryModel>>;
  public abstract upPriorityMasterCategory(
    masterCategory: ServiceMasterCategoryModel
  ): Observable<InteractorResponse<ServiceMasterCategoryModel>>;
  public abstract downPriorityMasterCategory(
    masterCategory: ServiceMasterCategoryModel
  ): Observable<InteractorResponse<ServiceMasterCategoryModel>>;
}
